// extracted by mini-css-extract-plugin
export var scrollArea = "_ni-0";